/**
 * T87 机甲：未改键 `getKeyboardKeys` 样例（layer0 system=0）→ 布局 HID / 分位值 → `pos`。
 * 与 `KEYBOARD_LAYOUTS.t87` 虚拟键盘回显、改键/灯光 pos 解析一致。
 */
const CB_VALUE_TO_HID: Readonly<Record<number, number>> = {
  65536: 224,
  131072: 225,
  262144: 226,
  524288: 227,
  1048576: 228,
  2097152: 229,
  4194304: 230,
  218103808: 61697,
};

/** 设备上报的 [value, pos]；来自 T87 实机 getKeyboardKeys({layer:0, system:0}) */
const T87_INIT_VALUE_POS: ReadonlyArray<readonly [number, number]> = [
  [41, 8],
  [53, 12],
  [43, 16],
  [57, 20],
  [131072, 24],
  [65536, 28],
  [30, 36],
  [20, 40],
  [4, 44],
  [29, 48],
  [524288, 52],
  [58, 56],
  [31, 60],
  [26, 64],
  [22, 68],
  [27, 72],
  [262144, 76],
  [59, 80],
  [32, 84],
  [8, 88],
  [7, 92],
  [6, 96],
  [60, 104],
  [33, 108],
  [21, 112],
  [9, 116],
  [25, 120],
  [61, 128],
  [34, 132],
  [23, 136],
  [10, 140],
  [5, 144],
  [44, 148],
  [62, 152],
  [35, 156],
  [28, 160],
  [11, 164],
  [17, 168],
  [63, 176],
  [36, 180],
  [24, 184],
  [13, 188],
  [16, 192],
  [64, 200],
  [37, 204],
  [12, 208],
  [14, 212],
  [54, 216],
  [4194304, 220],
  [65, 224],
  [38, 228],
  [18, 232],
  [15, 236],
  [55, 240],
  [218103808, 244],
  [66, 248],
  [39, 252],
  [19, 256],
  [51, 260],
  [56, 264],
  [101, 268],
  [67, 272],
  [45, 276],
  [47, 280],
  [52, 284],
  [68, 296],
  [46, 300],
  [48, 304],
  [69, 320],
  [42, 324],
  [49, 328],
  [40, 332],
  [2097152, 336],
  [1048576, 340],
  [70, 344],
  [73, 348],
  [76, 352],
  [80, 364],
  [71, 368],
  [74, 372],
  [77, 376],
  [82, 384],
  [81, 388],
  [72, 392],
  [75, 396],
  [78, 400],
  [79, 412],
];

function buildT87FactoryPosByKeycode(): Readonly<Record<number, number>> {
  const o: Record<number, number> = {};
  for (const [value, pos] of T87_INIT_VALUE_POS) {
    const hid = CB_VALUE_TO_HID[value] ?? value;
    o[hid] = pos;
  }
  /** 与 `KEYBOARD_LAYOUTS.t87` 底行 Menu 虚拟码一致 */
  o[21252] = o[101] ?? 268;
  return o;
}

export const T87_FACTORY_POS_BY_KEYCODE: Readonly<Record<number, number>> =
  buildT87FactoryPosByKeycode();
